import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES, TABS } from '../../../../../common/constants';

const NewTabs = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const [activeTabKey, setActiveTabKey] = useState(TABS?.DELIVERY?.key);

  const tabList = [
    {
      key: TABS?.CONFIRM_ORDER?.key,
      label: TABS?.CONFIRM_ORDER?.label,
      children,
    },
    {
      key: TABS?.ASSIGN_DELIVERY_PARTNER?.key,
      label: TABS?.ASSIGN_DELIVERY_PARTNER?.label,
      children,
    },
  ];

  useEffect(() => {
    if (location?.pathname?.includes(ROUTES?.NEW)) {
      setActiveTabKey(TABS?.CONFIRM_ORDER?.key);
    }
    if (location?.pathname?.includes(ROUTES?.ASSIGN_DELIVERY_PARTNER)) {
      setActiveTabKey(TABS?.ASSIGN_DELIVERY_PARTNER?.key);
    }
  }, [location]);

  const onTabChange = (key) => {
    setActiveTabKey(key);
    switch (key) {
      case TABS?.CONFIRM_ORDER?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.CONFIRM_ORDER}`,
        );
        break;
      case TABS?.ASSIGN_DELIVERY_PARTNER?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.ASSIGN_DELIVERY_PARTNER}`,
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="card-container mobile-card-main">
        <Tabs
          activeKey={activeTabKey}
          type="card"
          className="full-width"
          onChange={(key) => onTabChange(key)}
          items={tabList}
          destroyInactiveTabPane
        />
      </div>
    </>
  );
};

export default NewTabs;
